import { useTranslation } from 'react-i18next';
import s from './ChooseServices.module.scss';
import ServicesCard from './ServicesCard';
import Button from 'components/shared/Button';

const ChooseServices = ({
  services,
  selectedIds,
  handleChoose,
  handleNext,
  setDuration,
  setPrice,
  setSelectedServiceHistory,
  setBookingItemsWithDiscount
}: any) => {

  const {t} = useTranslation() as any
  const handleChooseService = item => {
    const isServiceAlreadySelected = selectedIds?.includes(item?.service);

    const selectedServices = isServiceAlreadySelected
      ? selectedIds?.filter(el => el !== item?.service)
      : [...selectedIds, item?.service];

    handleChoose(selectedServices);
    setSelectedServiceHistory(selectedServices);

    const selectedServicesDetails = services.filter(service =>
      selectedServices.includes(service?.service),
    );

    const totalDuration = selectedServicesDetails.reduce(
      (sum, service) => sum + (service?.duration || 0),
      0,
    );
    const totalPrice = selectedServicesDetails.reduce(
      (sum, service) => sum + (service?.price || 0),
      0,
    );

    setDuration(totalDuration);
    setPrice(totalPrice);
    setBookingItemsWithDiscount((prev) => {
      if (isServiceAlreadySelected) {
        return prev?.filter((x) => x?.service !== item?.service);
      }

      if (prev?.some((x) => x?.service === item?.service)) {
        return prev;
      }

      return [
        ...prev,
        {
          service: item?.service,
          price: item?.price
        }
      ];
    });
  };

  return (
    <div className={s.choose_services}>
      <div className={s.choose_services_title}>{t('Choose services')}</div>
      <div className={s.choose_services_cards}>
        {services?.length === 0 && <div>{t("No services")}</div>}
        {services?.map(item => {
          return (
            <div key={item.id} onClick={() => handleChooseService(item)}>
              <ServicesCard
                title={item?.services?.name}
                duration={item?.duration}
                price={item?.price}
                isSelected={selectedIds?.includes(item?.service)}
              />
            </div>
          );
        })}
      </div>
      <div>
        <Button
          className={s.choose_services_button}
          wide
          darkGreen
          disabled={!selectedIds?.length}
          onClick={handleNext}
        >
          {t('Book now')}
        </Button>
      </div>
    </div>
  );
};

export default ChooseServices;
